import { useCallback } from 'react';
import { useUserStore } from '@oai-frontend-monorepo/state-management';
import { captureException } from '@sentry/react';
import { oktaAuth } from '../okta';
import { parseToken } from '@oai-frontend-monorepo/utils';

export const _renewToken = async () => {
  try {
    console.log('_renewToken');

    const token = await oktaAuth.tokenManager.get('accessToken');
    console.log('current token', token);
    const newToken = await oktaAuth.tokenManager.renew('accessToken');

    if (newToken) {
      console.log('here', newToken);

      oktaAuth.tokenManager.add('accessToken', newToken);
      oktaAuth.tokenManager.setTokens({
        accessToken: newToken as any,
      });

      await oktaAuth.authStateManager.updateAuthState();

      useUserStore.getState().setToken((newToken as any)?.accessToken);

      return parseToken((newToken as any)?.accessToken as string);
    } else {
      throw new Error('Unable to renew token');
    }
  } catch (error) {
    console.log('error renewing token', error);
    captureException(error);
  }
};

const useRenewOktaToken = () => {
  const renewToken = useCallback(async () => {
    await _renewToken();
  }, []);

  return {
    renewToken,
  };
};

export default useRenewOktaToken;
